import React, { forwardRef } from 'react';

const CaretDown = ({ width = 24, height = 24, color = '#616161', ...rest }, ref) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...rest}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7688 7.73298C15.0771 8.04362 15.0771 8.54729 14.7688 8.8579L10.5582 13.1003C10.2499 13.411 9.75012 13.411 9.4418 13.1003L5.23123 8.8579C4.92292 8.54729 4.92292 8.04362 5.23123 7.73298C5.53954 7.42234 6.03941 7.42234 6.34772 7.73298L10 11.4129L13.6523 7.73298C13.9607 7.42234 14.4604 7.42234 14.7688 7.73298Z"
        fill={color}
      />
    </svg>
  );
};

export default forwardRef(CaretDown);
